import pageMode from "./page-mode";

export const isMadePdp = () =>
  document.getElementById("product-page-container")?.dataset?.madePdp === "true";

export const isMadePdpOrMadeMode = () => isMadePdp() || pageMode.isMadeMode;
